import { createTheme } from '@material-ui/core/styles'

export const themeDragOver = createTheme({
  overrides: {
    MuiPaper: {
      root: {
        backgroundColor: 'lightblue',
        width: '100%',
      },
    },
    MuiCardContent: {
      root: {
        padding: '0',
      },
    },
  },
})

export const themeDefault = createTheme({
  overrides: {
    MuiPaper: {
      root: {
        width: '100%',
        display: 'inline',
      },
    },
    MuiCardContent: {
      root: {
        padding: '0',
      },
    },
  },
})

export const modalDefault = createTheme({
  overrides: {
    MuiPaper: {
      root: {
        width: '100%',
        display: 'inline',
      },
    },
    MuiCardContent: {
      root: {
        padding: '0',
        '&:last-child': {
          paddingBottom: '0',
        },
      },
    },
    MuiGrid: {
      root: {
        width: '100%',
        '& [class*="MuiGrid-container-"]': {
          flexDirection: 'row !important',
        },
        '& [class*="MuiGrid-item-"]': {
          width: '100%',
          display: 'contents',
        },
      },
      item: {
        width: '100%',
        display: 'contents',
      },
      container: {
        flexDirection: 'row !important',
      },
    },
  },
})
